import { NotificationIntlMessages } from 'src/components/common/header/translations/useNotificationsIntl';

export const getTaskAssignedTitle = (intl: NotificationIntlMessages) => ({
  title: intl.taskAssignedToYouTitle,
  description: intl.taskAssignedToYouDescription
});

export const getTaskResolvedTitle = (intl: NotificationIntlMessages) => ({
  title: intl.taskResolvedTitle,
  description: intl.taskResolvedDescription
});
